/* tslint:disable */

declare var Object: any;
export interface TcltrequestInterface {
  "seqId"?: number;
  "sfobject": string;
  "companyId": number;
  "companyCode": string;
  "reqType": string;
  "reqMode": number;
  "reqNo": string;
  "reqDate": Date;
  "requester": number;
  "reqemp": string;
  "reqData": string;
  "keyData": string;
  "status": number;
  "isoutstanding": number;
  "isselectableApprover": number;
  "isexpired": number;
  "expiryDate"?: Date;
  "approvalList": string;
  "approvedList"?: string;
  "outstandingList"?: string;
  "emailList"?: string;
  "approvalPositionList"?: string;
  "approvalData"?: string;
  "approvedData"?: string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "isreroute"?: number;
  "nstepExpiryDate"?: Date;
  "nspareExpiryDate"?: Date;
  "outstandingListemail"?: string;
  teomemppersonals?: any;
  rel_elearning?: any;
  ttadleaverequests?: any;
  tgemreqstatuses?: any[];
}

export class Tcltrequest implements TcltrequestInterface {
  "seqId": number;
  "sfobject": string;
  "companyId": number;
  "companyCode": string;
  "reqType": string;
  "reqMode": number;
  "reqNo": string;
  "reqDate": Date;
  "requester": number;
  "reqemp": string;
  "reqData": string;
  "keyData": string;
  "status": number;
  "isoutstanding": number;
  "isselectableApprover": number;
  "isexpired": number;
  "expiryDate": Date;
  "approvalList": string;
  "approvedList": string;
  "outstandingList": string;
  "emailList": string;
  "approvalPositionList": string;
  "approvalData": string;
  "approvedData": string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "isreroute": number;
  "nstepExpiryDate": Date;
  "nspareExpiryDate": Date;
  "outstandingListemail": string;
  teomemppersonals: any;
  rel_elearning: any;
  ttadleaverequests: any;
  tgemreqstatuses: any[];
  constructor(data?: TcltrequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tcltrequest`.
   */
  public static getModelName() {
    return "Tcltrequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tcltrequest for dynamic purposes.
  **/
  public static factory(data: TcltrequestInterface): Tcltrequest{
    return new Tcltrequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tcltrequest',
      plural: 'Tcltrequests',
      path: 'Tcltrequests',
      properties: {
        "seqId": {
          name: 'seqId',
          type: 'number'
        },
        "sfobject": {
          name: 'sfobject',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "reqType": {
          name: 'reqType',
          type: 'string'
        },
        "reqMode": {
          name: 'reqMode',
          type: 'number'
        },
        "reqNo": {
          name: 'reqNo',
          type: 'string'
        },
        "reqDate": {
          name: 'reqDate',
          type: 'Date'
        },
        "requester": {
          name: 'requester',
          type: 'number'
        },
        "reqemp": {
          name: 'reqemp',
          type: 'string'
        },
        "reqData": {
          name: 'reqData',
          type: 'string'
        },
        "keyData": {
          name: 'keyData',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number'
        },
        "isoutstanding": {
          name: 'isoutstanding',
          type: 'number'
        },
        "isselectableApprover": {
          name: 'isselectableApprover',
          type: 'number'
        },
        "isexpired": {
          name: 'isexpired',
          type: 'number'
        },
        "expiryDate": {
          name: 'expiryDate',
          type: 'Date'
        },
        "approvalList": {
          name: 'approvalList',
          type: 'string'
        },
        "approvedList": {
          name: 'approvedList',
          type: 'string'
        },
        "outstandingList": {
          name: 'outstandingList',
          type: 'string'
        },
        "emailList": {
          name: 'emailList',
          type: 'string'
        },
        "approvalPositionList": {
          name: 'approvalPositionList',
          type: 'string'
        },
        "approvalData": {
          name: 'approvalData',
          type: 'string'
        },
        "approvedData": {
          name: 'approvedData',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "isreroute": {
          name: 'isreroute',
          type: 'number'
        },
        "nstepExpiryDate": {
          name: 'nstepExpiryDate',
          type: 'Date'
        },
        "nspareExpiryDate": {
          name: 'nspareExpiryDate',
          type: 'Date'
        },
        "outstandingListemail": {
          name: 'outstandingListemail',
          type: 'string'
        },
      },
      relations: {
        teomemppersonals: {
          name: 'teomemppersonals',
          type: 'any',
          model: ''
        },
        rel_elearning: {
          name: 'rel_elearning',
          type: 'any',
          model: ''
        },
        ttadleaverequests: {
          name: 'ttadleaverequests',
          type: 'any',
          model: ''
        },
        tgemreqstatuses: {
          name: 'tgemreqstatuses',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Tcltrequest.ts